module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-z1-3d8a6a01d165bb3505bcbcbc89ad6916.svg";